module.exports = __webpack_public_path__ + "fonts/adellesans-bold-webfont.9bfe10d8.woff";